import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';

export const fetchFunnels = createAsyncThunk('funnels/fetch', async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API}/funnels`);
    return res.data.funnels;
  } catch (e) {
    return rejectWithValue(e.response?.data?.message || 'Xato');
  }
});

const funnelSlice = createSlice({
  name: 'funnels',
  initialState: {
    list:    [],
    loading: false,
    loaded:  false,
  },
  reducers: {
    addFunnel(state, { payload }) {
      // Yaratuvchiga ham POST javobi, ham `funnel:created` socket hodisasi keladi —
      // ikkinchisi dublikat qo'shmasligi uchun _id bo'yicha tekshiramiz.
      const i = state.list.findIndex(f => f._id === payload._id);
      if (i !== -1) state.list[i] = payload;
      else state.list.push(payload);
    },
    updateFunnel(state, { payload }) {
      const i = state.list.findIndex(f => f._id === payload._id);
      if (i !== -1) state.list[i] = payload;
      // `order` o'zgargan bo'lishi mumkin — ro'yxatni qayta saralaymiz, aks
      // holda sidebar'dagi tartib yangi qiymatni darhol aks ettirmaydi.
      state.list.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    },
    removeFunnel(state, { payload }) {
      state.list = state.list.filter(f => f._id !== payload);
    },
    resetFunnels(state) {
      state.list = []; state.loaded = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFunnels.pending,  (state) => { state.loading = true; })
      .addCase(fetchFunnels.fulfilled, (state, { payload }) => {
        state.list = payload; state.loading = false; state.loaded = true;
      })
      .addCase(fetchFunnels.rejected, (state) => { state.loading = false; state.loaded = true; })
      // Boshqa akkauntga kirib chiqilganda oldingi tashkilotning voronkalari
      // Redux'da qolib ketmasligi uchun — shu bilan Sidebar/TopBar/BottomNav'dagi
      // `!loaded` shart(lar)i qayta fetchFunnels() chaqirishga majbur bo'ladi.
      // Action turini string sifatida tekshiramiz — authSlice'ni import qilib
      // aylanma (circular) bog'liqlik yaratmaslik uchun.
      .addCase('auth/logout', (state) => { state.list = []; state.loaded = false; });
  },
});

export const { addFunnel, updateFunnel, removeFunnel, resetFunnels } = funnelSlice.actions;
export default funnelSlice.reducer;
